import { createAction, props } from '@ngrx/store';
import { VehicleDto } from '@services/api/api.service';
import { VehicleCoords } from '@models/overview';

export const setVehicles = createAction(
  'setVehicles',
  props<{ value: VehicleDto[]; }>(),
);

export const setLoadingGeoview = createAction(
  'setLoadingGeoview',
  props<{ value: boolean }>(),
);

export const setTotalVehicles = createAction(
  'setTotalVehicles',
  props<{ value: number; }>(),
);
export const setSelectVehicle = createAction(
  'setSelectVehicle',
  props<{ value: VehicleDto; }>(),
);
export const setActiveVehicles = createAction(
  'setActiveVehicles',
  props<{ value: number; }>(),
);

export const setVehiclesCoords = createAction(
  'setVehiclesCoords',
  props<{ value: VehicleCoords[]; }>(),
);
export const setGeoviewFilters = createAction(
  'setGeoviewFilters',
  props<{ filters: any; }>(),
);

export const getGeoviewVehicles = createAction(
  'getGeoviewVehicles',
  props<{ user_id: string }>(),
);
